export default "__VITE_ASSET__yhOkmJhk__"